// src/ecrans/operations/OperationsTaches.jsx — « Opérations › Tâches » NEST
// (maquette v677, relevé 249) : Ma semaine · Tout · Faites · Notes.
//
// Lu SEULEMENT par les portes : ecran_taches_lire { vue: semaine | faites },
// ecran_notes_lire. ÉCRITURES hors lot (cocher, créer une tâche, une note) :
// boutons présents, inactifs, avec leur raison.

import { useState } from "react";
import { useLecture } from "../portes";
import { StyleNest, EtatLecture, LienAncien, C, jourEnLettres, jourCourt, pl } from "../nest";
import { tachesAFaire } from "../accueil/accueil-calculs";
import { sousTache, notesParPortee } from "./operations-calculs";

const CSS = `
.ntac-l{display:flex;align-items:center;gap:12px;background:#fff;border:1px solid ${C.bord};border-radius:12px;padding:10px 12px;margin-bottom:6px;min-height:56px}
.ntac-l .ck{width:20px;height:20px;border:1.5px solid #CDD4D1;border-radius:6px;flex-shrink:0;background:#fff}
.ntac-l .ck.fait{background:${C.vert};border-color:${C.vert}}
.ntac-l .t{display:block;font-size:13px;font-weight:600}
.ntac-l .s{display:block;font-size:11px;color:${C.gris};margin-top:2px}
.ntac-g{display:flex;align-items:center;gap:8px;font-size:12px;font-weight:600;margin:14px 2px 6px}
.ntac-g .n{margin-left:auto;font-size:10.5px;color:${C.grisD};font-weight:400}
.ntac-vide{display:flex;gap:8px;flex-wrap:wrap;align-items:center;font-size:11px;color:${C.gris};margin:10px 2px}
.ntac-vide span.j{border:1px dashed #CDD4D1;border-radius:9px;padding:5px 10px;background:#fff;color:${C.encre}}
`;

function LigneTache({ t, fait }) {
  return (
    <div className="ntac-l" data-testid={`tache-${t.id}`}>
      <span className={`ck${fait ? " fait" : ""}`} title="Cocher : une écriture, hors de ce lot." aria-hidden="true" />
      <span style={{ flex: 1, minWidth: 0 }}>
        <span className="t" style={fait ? { textDecoration: "line-through", color: C.gris } : undefined}>{t.titre}</span>
        <span className="s" style={t.retard ? { color: C.aubTx } : undefined}>{sousTache(t, jourCourt)}</span>
      </span>
    </div>
  );
}

function Semaine({ data }) {
  const jours = data.jours || [];
  const vides = jours.filter((j, i) => i > 0 && !j.taches.length);
  return (
    <>
      {data.en_retard && data.en_retard.length ? (
        <>
          <div className="ntac-g" style={{ color: C.aub }}>● En retard <span className="n">{data.en_retard.length}</span></div>
          {data.en_retard.map((t) => <LigneTache key={t.id} t={{ ...t, retard: true }} />)}
        </>
      ) : null}
      {jours.map((j, i) =>
        i === 0 || j.taches.length ? (
          <div key={j.date}>
            <div className="ntac-g">
              {i === 0 ? "Aujourd'hui" : jourEnLettres(j.date)}
              {i === 0 ? <span style={{ fontWeight: 400, color: C.gris, fontSize: 11 }}>{jourEnLettres(j.date).toLowerCase()}</span> : null}
            </div>
            {j.taches.length ? j.taches.map((t) => <LigneTache key={t.id} t={t} />) : <p className="nest-etat">Rien de prévu aujourd'hui.</p>}
          </div>
        ) : null,
      )}
      {vides.length ? (
        <div className="ntac-vide">
          Rien de prévu
          {vides.map((j) => <span key={j.date} className="j">{jourEnLettres(j.date).split(" ").slice(0, 2).join(" ").replace(/^\w/, (c) => c.toUpperCase())}</span>)}
        </div>
      ) : null}
      {data.sans_date && data.sans_date.length ? (
        <>
          <div className="ntac-g" style={{ color: C.gris }}>● Sans date <span className="n">{data.sans_date.length}</span></div>
          {data.sans_date.map((t) => <LigneTache key={t.id} t={t} />)}
        </>
      ) : null}
      {data.plus_tard ? <p className="nest-etat">{pl(data.plus_tard, "tâche")} plus tard (voir « Tout »).</p> : null}
    </>
  );
}

export default function OperationsTaches({ onAncien }) {
  const [vue, setVue] = useState("semaine");
  const [semaine, relireSemaine] = useLecture("ecran_taches_lire", { vue: "semaine" });
  const [faites, relireFaites] = useLecture(vue === "faites" ? "ecran_taches_lire" : null, { vue: "faites" });
  const [notes, relireNotes] = useLecture(vue === "notes" ? "ecran_notes_lire" : null, {});
  const ouvertes = semaine.etat === "ok" ? tachesAFaire(semaine.data) : null;
  const n = (l, calc) => (l.etat === "ok" ? calc(l.data) : null);
  const entrees = [
    ["semaine", "Ma semaine", null],
    ["tout", "Tout", ouvertes ? ouvertes.length : null],
    ["faites", "Faites", n(faites, (d) => d.taches.length)],
    ["notes", "Notes", n(notes, (d) => d.notes.length)],
  ];
  return (
    <div className="nest" data-testid="ops-taches">
      <StyleNest />
      <style>{CSS}</style>
      <div className="nest-page">
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 6 }}>
          <span className="nest-seg" style={{ flex: 1 }}>
            {entrees.map(([k, t, nb]) => (
              <button key={k} type="button" className={vue === k ? "on" : ""} onClick={() => setVue(k)}>
                {t}
                {nb !== null && nb !== undefined ? <small style={{ fontSize: 10 }}>{nb}</small> : null}
              </button>
            ))}
          </span>
          <button type="button" className="nest-bt p" disabled title="Créer une tâche : une écriture, hors de ce lot.">
            {vue === "notes" ? "+ Nouvelle note" : "+ Une tâche"}
          </button>
          <LienAncien pour="créer, cocher une tâche ou une note" onClick={onAncien} testId="taches-ancien" />
        </div>
        {vue === "semaine" ? (
          <>
            <EtatLecture lecture={semaine} quoi="Les tâches" onRelire={relireSemaine} />
            {semaine.etat === "ok" ? <Semaine data={semaine.data} /> : null}
          </>
        ) : null}
        {vue === "tout" ? (
          <>
            <EtatLecture lecture={semaine} quoi="Les tâches" onRelire={relireSemaine} />
            {ouvertes && !ouvertes.length ? <p className="nest-etat">Aucune tâche ouverte.</p> : null}
            {ouvertes ? ouvertes.map((t) => <LigneTache key={t.id} t={t} />) : null}
            {semaine.etat === "ok" && semaine.data.plus_tard ? (
              <p className="nest-manque">— {pl(semaine.data.plus_tard, "tâche")} au-delà de 7 jours : la porte les compte sans les lister.</p>
            ) : null}
          </>
        ) : null}
        {vue === "faites" ? (
          <>
            <EtatLecture lecture={faites} quoi="Les tâches faites" onRelire={relireFaites} />
            {faites.etat === "ok" && !faites.data.taches.length ? <p className="nest-etat">Aucune tâche faite.</p> : null}
            {faites.etat === "ok" ? faites.data.taches.map((t) => <LigneTache key={t.id} t={t} fait />) : null}
            {faites.etat === "ok" ? <p className="nest-etat">Elles restent visibles. Rien ne se supprime tout seul.</p> : null}
          </>
        ) : null}
        {vue === "notes" ? (
          <>
            <EtatLecture lecture={notes} quoi="Les notes" onRelire={relireNotes} />
            {notes.etat === "ok" && !notes.data.notes.length ? <p className="nest-etat">Aucune note.</p> : null}
            {notes.etat === "ok"
              ? notesParPortee(notes.data.notes).map((g) => (
                  <div key={g.portee}>
                    <p className="nest-inter">{g.libelle}</p>
                    {g.notes.map((x) => (
                      <div key={x.id} className="ntac-l" style={{ alignItems: "flex-start" }}>
                        <span style={{ flex: 1, minWidth: 0 }}>
                          {x.titre ? <span className="t">{x.titre}</span> : null}
                          <span className="s" style={{ whiteSpace: "pre-wrap", color: C.encre, fontSize: 12 }}>{x.texte}</span>
                          {x.logement ? <span className="s">{x.logement.nom}</span> : null}
                        </span>
                      </div>
                    ))}
                  </div>
                ))
              : null}
          </>
        ) : null}
      </div>
    </div>
  );
}
